import Mmenu from "mmenu-js";
import "mmenu-js/dist/mmenu.css";

// 1. Przygotowanie ikony SVG
const createArrowIcon = () => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("width", "17");
  svg.setAttribute("height", "11");
  svg.setAttribute("viewBox", "0 0 17 11");
  svg.setAttribute("fill", "none");
  svg.classList.add("submenu-arrow");

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", "M16 9.81934L8.36161 2.18094L0.723215 9.81934");
  path.setAttribute("stroke", "#181718");
  path.setAttribute("stroke-width", "2.01786");

  svg.appendChild(path);
  return svg;
};

document.addEventListener("DOMContentLoaded", () => {
  const menuElement = document.querySelector("#menu");
  const pageElement = document.querySelector("#page");

  if (!menuElement) return;

  // 2. Inicjalizacja mmenu
  const menuInstance = new Mmenu(menuElement, {
    extensions: ["theme-light", "fullscreen"],
    offCanvas: pageElement
      ? { position: "top", zposition: "front", container: pageElement }
      : { position: "top", zposition: "front" },
    navbars: [{ content: ["prev", "close"] }],
    // Wyłączamy automatyczne panele dla submenu, aby działały jako akordeon
    slidingSubmenus: false,
  });

  const menuApi = menuInstance.API;

  // 3. Obsługa Hamburgera
  const hamburger = document.querySelector('#header a[href="#menu"]');
  if (hamburger) {
    hamburger.addEventListener("click", (e) => {
      e.preventDefault();
      menuApi.open();
    });
  }

  // 4. Obsługa Submenu (Akordeon)
  const menuItemsWithSubmenu = menuElement.querySelectorAll(
    ".menu-item-has-children",
  );

  menuItemsWithSubmenu.forEach((item) => {
    const link = item.querySelector("a");
    const submenu = item.querySelector(".sub-menu");

    if (!link || !submenu) return;

    // Dodanie przycisku strzałki
    const btn = document.createElement("button");
    btn.classList.add("submenu-toggle-btn");
    btn.appendChild(createArrowIcon());
    link.after(btn);

    const toggleAction = (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Zamknij inne otwarte submenu (opcjonalnie)
      menuElement.querySelectorAll(".sub-menu.is-active").forEach((openSub) => {
        if (openSub !== submenu) {
          openSub.classList.remove("is-active");
          openSub.parentElement
            .querySelector(".submenu-toggle-btn")
            ?.classList.remove("rotate");
        }
      });

      // Toggle bieżącego
      submenu.classList.toggle("is-active");
      btn.classList.toggle("rotate");
    };

    // Kliknięcie w strzałkę ROZWIJA
    btn.addEventListener("click", toggleAction);

    // Jeśli link to "#", tekst też ROZWIJA
    if (link.getAttribute("href") === "#") {
      link.addEventListener("click", toggleAction);
    }
  });
});
